import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  dataContainer: {
    marginBottom: "16px",
    marginTop: "-24px",
  },

  total: {
    color: "#1D2939",
    fontFamily: "Manrope",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "44px", // 122.222%
  },

  value: {
    color: "#667085",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0.25px",
    lineHeight: "20px", // 142.857%
  },
}));

export default useStyles;
